/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import PropTypes from 'prop-types';

class Loading extends React.Component {
  render() {
    return (
      <div className="tc-loading">
        <div className="spinner-center">
          <svg className="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle className="path" fill="none" strokeWidth="3" cx="33" cy="33" r="30" />
          </svg>
        </div>
      </div>
    );
  }
}

Loading.propTypes = {
  children: PropTypes.node,
  strokeColor: PropTypes.string
};

export default Loading;
